import { ElMessage } from '@bilibili/magic-cube-plus';

// 对返回的json格式进行修改
export async function foramtRsp(response) {
    if (response.ok) {
        const json = await response.json();

        // 检查业务逻辑错误码
        if (json?.code !== 0) {
            // 显示错误提示
            json?.message && ElMessage.error(json?.message);
        }

        return json;
    }
    return Promise.reject({
        code: response.status,
        message: response.status === 504 ? '操作超时，请重试' : '请求出错，稍后再试'
    });
}
// 对返回的json格式进行修改
export function notNetHandle(response) {
    if (/Failed to fetch/.test(response.message)) {
        return Promise.reject({
            code: 411,
            message: '网络异常，请检查网络连接'
        });
    }
    return Promise.reject(response);
}
// 查询字符串的拼接
export function queryString(data) {
    const body = [];
    for (const [key, value] of Object.entries(data)) {
        body.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    return body.join('&');
}
/**
 * @name: polling
 * @msg: 轮询接口
 * @param {*} call call地址
 * @param {*} back back地址
 * @param {*} params call的请求参数
 * @return {*} promise
 */
export function polling(call, back, params) {
    const backFn = (taskId, resolve, reject) =>
        back(taskId)
            .then((data) => {
                if (data.code === 1) {
                    setTimeout(() => {
                        backFn(taskId, resolve, reject);
                    }, 1000);
                } else {
                    resolve(data.data);
                }
            })
            .catch((err) => {
                reject(err);
            });
    return new Promise((resolve, reject) => {
        call(params)
            .then((taskId) => {
                if (taskId) {
                    backFn(taskId, resolve, reject);
                } else {
                    reject('获取taskId失败');
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export default {
    post(url, data = {}, type = 'form', headers) {
        if (type === 'json') {
            return fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => foramtRsp(response))
                .catch((response) => notNetHandle(response));
        }
        return fetch(url, {
            method: 'POST',
            body: queryString(data),
            credentials: 'include',
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then((response) => foramtRsp(response))
            .catch((response) => notNetHandle(response));
    },
    delete(url, data = {}, headers) {
        return fetch(url, {
            method: 'DELETE',
            body: queryString(data),
            credentials: 'include',
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then((response) => foramtRsp(response))
            .catch((response) => notNetHandle(response));
    },
    get(url, data = {}, headers) {
        const qs = queryString(data);
        if (qs !== '') {
            const seq = url.indexOf('?') === -1 ? '?' : '&';
            url = url + seq + qs;
        }
        return fetch(url, {
            credentials: 'include',
            headers: {
                ...headers
            }
        })
            .then((response) => foramtRsp(response))
            .catch((response) => notNetHandle(response));
    },
    postFile(url, formData = {}, headers) {
        return fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'include',
            headers: {
                ...headers
            }
        })
            .then((response) => foramtRsp(response))
            .catch((response) => notNetHandle(response));
    }
};
